/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelPurchaseAdminResponseModel } from '../../models/paged-model-purchase-admin-response-model';

export interface ListAllPurchasesByMerchantId$Params {
  merchantId: string;
  pageable: Pageable;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function listAllPurchasesByMerchantId(http: HttpClient, rootUrl: string, params: ListAllPurchasesByMerchantId$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelPurchaseAdminResponseModel>> {
  const rb = new RequestBuilder(rootUrl, listAllPurchasesByMerchantId.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.query('pageable', params.pageable, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelPurchaseAdminResponseModel>;
    })
  );
}

listAllPurchasesByMerchantId.PATH = '/merchants/{merchantId}/purchases';
